import { useNavigation } from '@/app/hooks'
import useMultiProgramFlowControl from '@/hooks/useMultiProgramFlowControl'
import { UtilityConnectionResult } from '@/types/utility-connection/utility-connection'
import { fetchAuthenticatedJSONResult } from '@/utils/fetch/fetchAuthenticated'
import { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { match } from 'ts-pattern'
type ConnectionStatus = 'loading' | 'success' | 'error'
export function useUtilityConnectionViewModel() {
  const { provider } = useParams<{ provider: string }>()
  const navigate = useNavigation()
  const location = useLocation()
  const { flowStartUrl } = useMultiProgramFlowControl()
  const [connectionStatus, setConnectionStatus] =
    useState<ConnectionStatus>('loading')
  const verifyConnection = async () => {
    const connectionResult =
      await fetchAuthenticatedJSONResult<UtilityConnectionResult>(
        `/utility-connection/${provider}/create`,
        { method: 'POST' },
        location.search,
      )
    if (connectionResult.isErr()) {
      setConnectionStatus('error')
      return
    }
    setConnectionStatus('success')
  }
  const getProviderErrors = () => {
    const searchParams = new URLSearchParams(location.search)
    // this may need to be expanded later, or perhaps dealt with on the backend entirely but
    // for now it encompases support for both Leap & Voltus - they both use this error search param
    return searchParams.get('error')
  }
  const onButtonClick = () => {
    if (connectionStatus === 'loading') {
      navigate.push(`${flowStartUrl}`)
      return
    }
    if (!flowStartUrl) {
      // should never get here, but we need to go _somewhere_ if it happens
      navigate.push('/devices')
      return
    }
    match(connectionStatus)
      .with('success', () =>
        navigate.push(
          `${flowStartUrl}?utility-connect-success=${
            connectionStatus === 'success'
          }`,
        ),
      )
      .with('error', () => navigate.push(`${flowStartUrl}`))
      .exhaustive()
  }
  useEffect(() => {
    const providerErrors = getProviderErrors()
    if (providerErrors) {
      setConnectionStatus('error')
      return
    }
    verifyConnection()
  }, [])
  return { connectionStatus, onButtonClick }
}
